import { render, staticRenderFns } from "./TableCompanyOnlyTokens.vue?vue&type=template&id=04a9dcde"
import script from "./TableCompanyOnlyTokens.vue?vue&type=script&lang=js"
export * from "./TableCompanyOnlyTokens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports